import { Box, Typography } from "@mui/material";
import { colors } from "../../../theme/palette";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "100%",
        padding: "10px 0",
        textAlign: "center",
        backgroundColor: colors.white,
      }}
    >
      <Typography variant="body10Regular" color="#4B504B">
        {t("layout.footer.copyRights")}
      </Typography>
    </Box>
  );
};

export default Footer;
